<template lang="pug">
    div.profile-files-container-control
        div.profile-files-container-control__header
            div.profile-files-container-control__title {{ title }}
            div.profile-files-container-control__grow
            slot(name="actions")
                div.profile-files-container-control__link(@click="clickDefaultAction") {{ actionTitle }}
        div.profile-files-container-control__content
            slot
</template>

<script>
export default {
    name: 'profile-files-container-control',
    props: {
        title: {
            type: String,
            required: true,
        },
        actionTitle: {
            type: String,
            default: 'See all',
        },
    },
    methods: {
        clickDefaultAction() {
            this.$emit('defaultAction')
        },
    },
}
</script>
